// extracted by mini-css-extract-plugin
export default {"number":"ItemPrice-module__number___uLVH8","primary":"ItemPrice-module__primary___1HFpf","crossed":"ItemPrice-module__crossed___1z2GY"};